/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import Button from '../buttons/Rounded';

import styles from '../../../styles/partials/icon-link.module.scss';

const propTypes = {
    iconPosition: PropTypes.oneOf(['left', 'right', 'inline']),
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    secondary: PropTypes.bool,
    isDark: PropTypes.bool,
    isCompact: PropTypes.bool,
    onClick: PropTypes.func,
    scrollTop: PropTypes.bool,
    disabled: PropTypes.bool,
    isFocusable: PropTypes.bool,
};

const defaultProps = {
    iconPosition: 'inline',
    className: null,
    iconClassName: null,
    secondary: false,
    isDark: false,
    isCompact: false,
    onClick: null,
    scrollTop: false,
    disabled: false,
    isFocusable: false,
};

const IconLink = ({
    className,
    iconClassName,
    iconPosition,
    secondary,
    isDark,
    isCompact,
    onClick,
    scrollTop,
    disabled,
    isFocusable,
    ...props
}) => {
    const scroll = useCallback(() => {
        window.scroll({
            top: 0,
            // behavior: 'smooth',
        });
    }, []);

    const onClickLink = useCallback(
        (...args) => {
            if (scrollTop) {
                if (onClick !== null) {
                    scroll();
                    onClick(...args);
                } else {
                    scroll();
                }
            } else if (onClick !== null) {
                onClick(...args);
            }
        },
        [scrollTop, onClick],
    );

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.secondary]: secondary,
                    [styles.isDark]: isDark,
                    [styles.isCompact]: isCompact,
                    [styles.disabled]: disabled,
                },
            ])}
            iconClassName={classNames([
                styles.icon,
                {
                    [styles[iconPosition]]: typeof styles[iconPosition] !== 'undefined',
                    [iconClassName]: iconClassName !== null,
                },
            ])}
            iconPosition={iconPosition}
            disabled={disabled}
            onClick={onClickLink}
            tabIndex={isFocusable ? '' : '-1'}
            isDark={isDark}
            {...props}
        />
    );
};
IconLink.propTypes = propTypes;
IconLink.defaultProps = defaultProps;

export default IconLink;
